import {
  Button as ButtonAntd,
  Modal as ModalAtnd,
  Typography as TypographyAntd,
} from 'antd';
import styled from 'styled-components';

export const Modal = styled(ModalAtnd)`
  .ant-modal-header {
    border-bottom: 1px solid #bdbdbd;
  }

  .ant-modal-title {
    color: #4f4f4f;
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
  }
`;

export const Button = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  padding: 0px 31px;
  border: 1px solid #75aa4a;
  border-radius: 4px !important;
  background: #75aa4a;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    border-color: #add290;
    background-color: #add290;
  }
`;

export const CancelarButton = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #000;
  padding: 8px 20px;
  border: none;
  background: #fff;

  &:hover,
  &:focus,
  &:active {
    color: #add290;
  }
`;

export const Title = styled(TypographyAntd.Title)`
  font-weight: bold !important;
  font-size: 20px !important;
  line-height: 23px !important;
  letter-spacing: 0.25px !important;
  color: #4f4f4f !important;
`;

export const Text = styled(TypographyAntd.Text)`
  padding: 0 115px;
  text-align: center;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.25px;
  color: #828282;
`;

export const Strong = styled.strong`
  font-weight: bold;
`;
